import { createContext, useContext } from "react";

export type ArcTokenResult =
  | { status: "ok"; token: string }
  | { status: "unauthenticated" }
  | { status: "not_selected" }
  | { status: "forbidden" }
  | { status: "ip_restricted" }
  | { status: "error" };

export type ArcTokenContextType = {
  ensureToken: () => Promise<ArcTokenResult>;
  refreshToken: () => Promise<ArcTokenResult>;
};

export const ArcTokenContext = createContext<ArcTokenContextType | null>(null);

export function useArcToken(): ArcTokenContextType {
  const ctx = useContext(ArcTokenContext);
  if (!ctx) {
    throw new Error("useArcToken must be used within ArcTokenProvider");
  }
  return ctx;
}
